var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (slides, undefined) {
buf.push("<div id=\"lesson-slides\" class=\"block-h-lg content-fill\"><div id=\"slides\" class=\"content-fill\"><div id=\"slides-scroller\" class=\"content-fill\">");
// iterate slides
;(function(){
  var $$obj = slides;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var slide = $$obj[$index];

buf.push("<div" + (jade.cls(['slide','text-break',"slide-" + (slide.type) + ""], [null,null,true])) + "></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var slide = $$obj[$index];

buf.push("<div" + (jade.cls(['slide','text-break',"slide-" + (slide.type) + ""], [null,null,true])) + "></div>");
    }

  }
}).call(this);

buf.push("</div></div></div>");}.call(this,"slides" in locals_for_with?locals_for_with.slides:typeof slides!=="undefined"?slides:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}